export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14145.94e09ebd.jpg";